import React from 'react';
import PropTypes from 'prop-types';
import { allSections } from 'components/sections';
import { PREHEADER, HEADER, FIXED_TOP, BODY, FIXED_BOTTOM, FOOTER } from 'utils/sectionTypes';
import WidgetLoader from 'components/WidgetLoader/WidgetLoader';

const renderSubsections = ({
  section,
  widgets,
  widgetLoader,
  widgetLoaderProps,
}) => section.details.subsections.map((subsection, index) => (
  React.createElement(
    widgetLoader,
    {
      key: `widget-${index}`,
      ...(widgets[index] || {}),
      ...widgetLoaderProps,
    },
  )
));
const SectionLoader = ({
  id,
  type,
  data = {},
  payload = {},
  widgets = [],
  widgetLoader = WidgetLoader,
  widgetLoaderProps = {},
  searching,
  pageType,
  sectionIdx,
  ...props
}) => {
  const section = allSections[type];

  // To prevent whitescreens, we bail on deleted sections
  if (!section) {
    return false;
  }

  if (props.pageFacilityId) widgetLoaderProps.pageFacilityId = props.pageFacilityId;

  if (payload && payload.sectionStyle) {
    widgetLoaderProps.sectionStyle = payload.sectionStyle;
  }

  const lazyBody = section.details.region === BODY && sectionIdx > 4;
  const lazy = [FIXED_BOTTOM, FOOTER].includes(section.details.region);
  const preload = [PREHEADER, HEADER, FIXED_TOP].includes(section.details.region);

  if (lazyBody || lazy) {
    widgetLoaderProps.lazy = true;
  }

  if (!lazyBody && !lazy) {
    widgetLoaderProps.eager = true;
  }

  if (preload) {
    widgetLoaderProps.preload = true;
  }

  return React.createElement(
    section,
    {
      isEditable: false,
      isEditing: false,
      id,
      searching,
      pageType,
      ...(section.details.defaultPayload || {}),
      ...data,
      ...payload,
      payload,
      ...props,
    },
    renderSubsections({
      section,
      widgets,
      widgetLoader,
      widgetLoaderProps,
    }),
  );
};

SectionLoader.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  data: PropTypes.object,
  payload: PropTypes.object,
  widgets: PropTypes.array,
  widgetLoader: PropTypes.any, // todo: Find a better prop type for this
  widgetLoaderProps: PropTypes.object,
  pageFacilityId: PropTypes.string,
  searching: PropTypes.bool,
  pageType: PropTypes.string.isRequired,
  sectionIdx: PropTypes.number,
};

export default SectionLoader;
